import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { JsonParseInterceptor } from './interceptors/json-parse.interceptor';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { CookieInterceptor } from './interceptors/cookie.interceptor';
import { ErrorInterceptor } from './interceptors/error.interceptor';
import { SecurityInterceptor } from './interceptors/security.interceptor';
import { LoadingInterceptor } from './interceptors/loading.interceptor';
import { LogDisplayComponent } from './components/log-display/log-display.component';
import { MatDividerModule } from '@angular/material/divider';
import { IconModule } from '@visurel/iconify-angular';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    LogDisplayComponent
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    MatSnackBarModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    MatDialogModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatRadioModule,
    MatSelectModule,
    MatMenuModule,
    IconModule,
    MatDividerModule
  ],  
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JsonParseInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: CookieInterceptor, multi: true }, 
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: SecurityInterceptor, multi: true }, 
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true }        
  ],
  exports: [
    HttpClientModule
  ]
})
export class SharedModule { }
